
import React from 'react';
import { PortfolioItem } from './types';
import { Icon } from './components/Icon';

interface PortfolioMultimediaProps {
  items: PortfolioItem[];
  onBack: () => void;
}

const PortfolioMultimedia: React.FC<PortfolioMultimediaProps> = ({ items, onBack }) => {
  const multimediaItems = items.filter(item => item.category === 'multimedia');

  return (
    <div className="min-h-screen bg-[#030712] pt-32 pb-20 text-white">
      <div className="container mx-auto px-6">
        <button 
          onClick={onBack}
          className="flex items-center gap-2 text-slate-400 hover:text-white mb-8 transition-colors group"
        >
          <div className="p-2 glass-morphism rounded-lg group-hover:bg-white/10">
            <Icon name="ArrowRight" className="rotate-180" size={18} />
          </div>
          <span>Kembali ke Beranda</span>
        </button>

        <div className="mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Multimedia <span className="gradient-text">Interaktif</span></h1>
          <p className="text-slate-400 max-w-2xl">Karya interaktif mulai dari game edukasi, simulasi, hingga media pembelajaran digital inovatif.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {multimediaItems.length > 0 ? multimediaItems.map((item) => (
            <div key={item.id} className="glass-morphism rounded-3xl overflow-hidden border border-white/10 hover:border-green-500/50 transition-all group">
              <div className="aspect-video relative overflow-hidden">
                <img 
                  src={item.imageUrl || `https://picsum.photos/seed/${item.id}/600/400`} 
                  alt={item.title} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6">
                   <a 
                    href={item.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg shadow-green-500/20"
                   >
                     Mainkan Sekarang <Icon name="PlayCircle" size={14} />
                   </a>
                </div>
              </div>
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-bold">{item.title}</h3>
                  <div className="p-2 bg-green-500/10 rounded-lg">
                    <Icon name="Gamepad" className="text-green-500" size={16} />
                  </div>
                </div>
                <p className="text-slate-400 text-sm mb-6 line-clamp-2">{item.description}</p>
                <div className="flex items-center justify-between pt-4 border-t border-white/5">
                   <span className="text-[10px] font-extrabold text-slate-500 uppercase tracking-widest">Interactive Media</span>
                   <a 
                    href={item.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-400 font-bold text-xs hover:underline flex items-center gap-1"
                   >
                    Buka Link <Icon name="ExternalLink" size={12} />
                   </a>
                </div>
              </div>
            </div>
          )) : (
            <div className="col-span-full py-20 text-center glass-morphism rounded-3xl border border-dashed border-white/20">
              <p className="text-slate-500">Belum ada portofolio multimedia yang ditambahkan.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioMultimedia;
